import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import config from 'SRC/config/config.json'

export const Head = ({ packages }) => {
  const { t } = useTranslation('common')

  return (
    <tr>
      <th>{t(config.registrationForm.package.head)}</th>
      {
        packages.map(item => <th key={item.id}>{item.name}</th>)
      }
    </tr>
  )
}

Head.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired
}

Head.defaultProps = {
  packages: []
}
